export default function imageLoader({ src, width, quality }: { src: string; width: number; quality?: number }) {
  let url = src
  const baseCacheUrl = process.env.NEXT_PUBLIC_BASE_CACHE_URL || process.env.BASE_CACHE_URL
  if (!src.startsWith('http') && baseCacheUrl != undefined) {
    const urlModule = new URL(baseCacheUrl)
    urlModule.pathname = src
    url = urlModule.toString()
  }

  return `/_next/image?w=${width}&q=${quality || 75}&url=${encodeURIComponent(url)}`
}
